export default "__VITE_ASSET__CDfv0ObS__"